import script from "./MobileOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileOrders.vue?vue&type=script&setup=true&lang=js"

import "./MobileOrders.vue?vue&type=style&index=0&id=3d51cb31&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d51cb31"]])

export default __exports__